import { registerViewMount } from './navigation.js';
import { appendTrustedAdminViewFragment } from './trusted-admin-view-fragment.js';

let aiRolesMountPromise = null;

export function initAiRolesViewFragment() {
  registerViewMount('admin-ai-roles', mountAiRolesView);
}

async function mountAiRolesView() {
  if (document.getElementById('view-admin-ai-roles')) return;
  if (aiRolesMountPromise) return aiRolesMountPromise;

  aiRolesMountPromise = mountAdminViewFragment('/admin-views/ai-roles.html', 'Unable to load AI roles view');
  try {
    await aiRolesMountPromise;
  } catch (error) {
    aiRolesMountPromise = null;
    throw error;
  }
}

async function mountAdminViewFragment(path, failureMessage) {
  const host = document.getElementById('admin-lazy-view-host');
  await appendTrustedAdminViewFragment(host, path, failureMessage);
}
